import styled from 'styled-components';

export const StyledBagelCodeBalance = styled.div`
    display: inline-flex;
    align-items: center;
    font-weight: 400;
    padding: 4px 8px;
    margin-right: 4px;
    background: #090535;
    border: 1px solid #5442c3;
    border-radius: 16px;
    color: #ffffff;
    font-size: 16px;
    font-family: 'Roboto', sans-serif;

    .balanceImg {
        height: 20px;
        aspect-ratio: 1/1;
        margin-right: 4px;
        background-color: transparent;
    }
`;
